import SortableTableHeader from "./SortableTableHeader.svelte";
import Root from "./Table.svelte";
import TableBody from "./TableBody.svelte";
import TableCell from "./TableCell.svelte";
import TableHead from "./TableHead.svelte";
import TableHeader from "./TableHeader.svelte";
import TableRow from "./TableRow.svelte";
export const Table = Object.assign(Root, {
    Body: TableBody,
    Cell: TableCell,
    Head: TableHead,
    Header: TableHeader,
    Row: TableRow,
    SortableHeader: SortableTableHeader,
});
